// Although this is an API key, it only has access to public content and is thus safe to place here and check-in to the repo
export const CONTENTFUL_API_KEY = "gKLCHHjrcIGzgsaCkcVe0beYVC-YWPunITZoU0flz7U";
export const CONTENTFUL_SPACE_KEY = "hscjk4r1xq6f";